import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MenuService } from '@app/core/services/menu/menu.service';
import { CustomHomeComponent } from '@app/custom-home/custom-home.component';
import { LocalService } from '@app/shared/services/local.service';
import { NavigationHelper } from '../util/NavigationHelper';
import { CustomAuthenticationService } from '@app/auth/services/custom-authentication.service';
import { SharedVariable } from '../util/shared-variable';
import { DashboardLogService } from '@app/core/services-api/dashboardLog.service';

@Component({
  selector: 'app-custom-dashboards',
  templateUrl: './custom-dashboards.component.html',
  styleUrls: ['./custom-dashboards.component.scss']
})
export class CustomDashboardsComponent implements OnInit {
  permissions = this.secureStorage.getJsonValue('permissions')
  bntStyle: string = "first-level-menu";
  first_active_menu: any;
  reports_menu: any;
  second_active_menu: any;
  third_active_menu: any;
  first_selectedMenuEntry: string;
  second_selectedMenuEntry: string;
  third_selectedMenuEntry: string;
  isOperationMenu: boolean = false;
  isReportsMenu: boolean = false;

  constructor(
    private shared: SharedVariable,
    private customAuthenticationService: CustomAuthenticationService,
    private secureStorage: LocalService,
    private mainComponent: CustomHomeComponent, 
    private menuService: MenuService, 
    private router: Router,
    private dashboardLogService: DashboardLogService
  ) { }

  ngOnInit(): void {

    if (localStorage.getItem("s3brazilwebportalfe_locale_id") == "pt"){
      this.menuDash =[{label: 'Status de Operações',role:'Dash - Operações'},{label: 'Caixa online',role:'Dash - Caixa on line'},{label: 'Status de cotas',role:'Dash - Cotas do Fundo'},{label: 'P&L',role:'Dash - PL'},{label: 'Acumulado de gestão',role:'Dash - Acumulado Gestão'}
        /* ,{label: 'Insumos Pendentes',role:'Dash - Insumos Pendentes'} */]

    }
    else{
      this.menuDash =[{label: 'Transaction Status',role:'Dash - Operações'},{label: 'Online cash',role:'Dash - Caixa on line'},{label: 'Quota status',role:'Dash - Cotas do Fundo'},{label: 'P&L',role:'Dash - PL'},{label: 'Management accrual',role:'Dash - Acumulado Gestão'}
        /* ,{label: 'Pending Inputs',role:'Dash - Insumos Pendentes'} */]
    }

  }


  initScreen() {
   
  }
  getTranslatedLabel(label){

  }
  menuDash:any[]  = [{label: 'Status de Operações',role:'Dash - Operações'},{label: 'Caixa online',role:'Dash - Caixa on line'},{label: 'Status de cotas',role:'Dash - Cotas do Fundo'},{label: 'P&L',role:'Dash - PL'},{label: 'management-accrual',role:'Dash - Acumulado Gestão'}
    //,{label: 'Pending Inputs',role:'Dash - Insumos Pendentes'}
    ]
  filterMenuDash(): any[] {
    if (this.permissions) {
      return this.filterDashboarsByRole();
    } else {
      setTimeout(() => {
        this.permissions = this.secureStorage.getJsonValue('permissions')

        this.filterMenuDash();
      }, 1000);
    }
  }

  filterDashboarsByRole() {
    return this.menuDash.filter(item => {
      return this.customAuthenticationService.hasPermission(item.role);
    });
  }

 
  
  
 

  

  public isDashboardHomeActive: boolean = true;
  public idDashboardOpeartionsActive : boolean = false;
  public isDashboardOnlineCashActive: boolean = false;
  public isDashboardCotasActive: boolean = false;
  public isDashboardPLActive: boolean = false;
  public isDashboardAccumulatedManagementActive: boolean = false;
    public isDashboardInsumosPendentesActive: boolean = false;

  firstLevelClicked(item: any) {

    this.mainComponent.isDashboardOpen = false
    this.mainComponent.displayDashboard = false
    if (item.role=="Dash - Operações"){
      this.shared.idDashboardOpeartionsActive = true;
      this.shared.isDashboardHomeActive = false;
      this.shared.isDashboardOnlineCashActive = false;
      this.shared.isDashboardCotasActive = false;
      this.shared.isDashboardPLActive = false;
      this.shared.isDashboardAccumulatedManagementActive = false;
      this.shared.isDashboardInsumosPendentesActive =false;
      
      // Log dashboard operation access if data is available
      if (this.shared.dashboardOperationLogStatus !== null && this.shared.dashboardOperationLogDate !== null) {
        this.dashboardLogService.setDashboardLog(
          "Dash Principal - Status de Operações",
          this.shared.dashboardOperationLogStatus,
          null,
          this.shared.dashboardOperationLogDate
        );
        // Reset after logging
       // this.shared.dashboardOperationLogStatus = null;
       // this.shared.dashboardOperationLogDate = null;
      }
      
    }
    else if (item.role=="Dash - Caixa on line"){
      this.shared.idDashboardOpeartionsActive = false;
      this.shared.isDashboardHomeActive = false;
      this.shared.isDashboardOnlineCashActive = true;
      this.shared.isDashboardCotasActive = false;
      this.shared.isDashboardPLActive = false;
      this.shared.isDashboardAccumulatedManagementActive = false;
      this.shared.isDashboardInsumosPendentesActive =false;

      // Log dashboard caixa online access if data is available
      if (this.shared.dashboardCaixaOnlineLogStatus !== null && this.shared.dashboardCaixaOnlineLogDate !== null) {
        this.dashboardLogService.setDashboardLog(
          "Dash Principal - Caixa on-line",
          this.shared.dashboardCaixaOnlineLogStatus,
          null,
          this.shared.dashboardCaixaOnlineLogDate
        );
        // Reset after logging
     //   this.shared.dashboardCaixaOnlineLogStatus = null;
       // this.shared.dashboardCaixaOnlineLogDate = null;
      }
    }
    else if (item.role=="Dash - Cotas do Fundo"){
      this.shared.idDashboardOpeartionsActive = false;
      this.shared.isDashboardHomeActive = false;
      this.shared.isDashboardOnlineCashActive = false;
      this.shared.isDashboardCotasActive = true;
      this.shared.isDashboardPLActive = false;
      this.shared.isDashboardAccumulatedManagementActive = false;
      this.shared.isDashboardInsumosPendentesActive =false;

      // Log dashboard status cotas access if data is available
      if (this.shared.dashboardStatusCotasLogStatus !== null && this.shared.dashboardStatusCotasLogDate !== null) {
        this.dashboardLogService.setDashboardLog(
          "Dash Principal - Status de Cotas",
          this.shared.dashboardStatusCotasLogStatus,
          null,
          this.shared.dashboardStatusCotasLogDate
        );
        // Reset after logging
      //  this.shared.dashboardStatusCotasLogStatus = null;
      //  this.shared.dashboardStatusCotasLogDate = null;
      }
    }
    else if(item.role=="Dash - PL"){
      this.shared.idDashboardOpeartionsActive = false;
      this.shared.isDashboardHomeActive = false;
      this.shared.isDashboardOnlineCashActive = false;
      this.shared.isDashboardCotasActive = false;
      this.shared.isDashboardPLActive = true;
      this.shared.isDashboardAccumulatedManagementActive = false;
      this.shared.isDashboardInsumosPendentesActive =false;

      // Log dashboard PL access directly on click
      this.dashboardLogService.setDashboardLog(
        "Dash Principal - PL",
        "OK",
        null,
        new Date()
      );

    }
    else if (item.role=="Dash - Acumulado Gestão"){
      this.shared.idDashboardOpeartionsActive = false;
      this.shared.isDashboardHomeActive = false;
      this.shared.isDashboardOnlineCashActive = false;
      this.shared.isDashboardCotasActive = false;
      this.shared.isDashboardPLActive = false;
      this.shared.isDashboardAccumulatedManagementActive  = true;
      this.shared.isDashboardInsumosPendentesActive =false;

      // Log dashboard Acumulado Gestão access directly on click
      this.dashboardLogService.setDashboardLog(
        "Dash Principal - Acumulado de Gestão",
        "OK",
        null,
        new Date()
      );

    }
    else if (item.role=="Dash - Insumos Pendentes"){
      this.shared.idDashboardOpeartionsActive = false;
      this.shared.isDashboardHomeActive = false;
      this.shared.isDashboardOnlineCashActive = false;
      this.shared.isDashboardCotasActive = false;
      this.shared.isDashboardPLActive = false;
      this.shared.isDashboardAccumulatedManagementActive  = false;
      this.shared.isDashboardInsumosPendentesActive=true;
    }
    if (this.router.url != '/dashboard'){
      this.router.navigateByUrl('/dashboard');
    }

  }





  sortMenuEntries(list: any) {
    return list.sort(function (a, b) {
      return a.label.localeCompare(b.label);
    });
  }

}
